<script>
    import {authComputed} from '@state/helpers'
    import store from "@state/store";

    export default {
        components: {},
        props: {
            // user: {
            //     type: Object,
            //     required: false,
            //     default: () => ({}),
            // },
            isMenuOpened: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return { }
        },
        computed: {
            ...authComputed,
            districts () {
                return this.$store.state.districts
            },
            user () {
                return this.$store.state.loginInUser
            },
            entitled_categories () {
                return this.$store.state.entitled_categories
            },
            userPermission () {
              return this.$store.state.user
            },
            userRole () {
              return this.$store.state.role
            }
        },
        mounted() {
            var links = document.getElementsByClassName('side-nav-link-ref')
            var matchingMenuItem = null
            for (var i = 0; i < links.length; i++) {
                if (window.location.pathname === links[i].pathname) {
                    matchingMenuItem = links[i]
                    break
                }
            }

            if (matchingMenuItem) {
                matchingMenuItem.classList.add('active')
                var parent = matchingMenuItem.parentElement

                /**
                 * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
                 * We should come up with non hard coded approach
                 */
                if (parent) {
                    parent.classList.add('active')
                    const parent2 = parent.parentElement
                    if (parent2) {
                        parent2.classList.add('in')
                    }
                    const parent3 = parent2.parentElement
                    if (parent3) {
                        parent3.classList.add('active')
                        var childAnchor = parent3.querySelector('.has-dropdown')
                        if (childAnchor) childAnchor.classList.add('active')
                    }

                    const parent4 = parent3.parentElement
                    if (parent4) parent4.classList.add('in')
                    const parent5 = parent4.parentElement
                    if (parent5) parent5.classList.add('active')
                }
            }
        },
        methods: {
            onMenuClick(event) {
                event.preventDefault()
                const nextEl = event.target.nextSibling
                if (nextEl && !nextEl.classList.contains('open')) {
                    const parentEl = event.target.parentNode
                    if (parentEl) {
                        parentEl.classList.remove('open')
                    }

                    nextEl.classList.add('open')
                } else if (nextEl) {
                    nextEl.classList.remove('open')
                }
                return false
            },
            /**
             * Dark Menubar
             */
            darkTopbar() {
                document.body.classList.add('topbar-dark')
                document.body.classList.remove('topbar-light')
                document.body.classList.remove('unsticky-header')
                document.body.classList.remove('boxed-layout')
                document.body.classList.remove('drop-menu-dark')
                document.body.classList.remove('menubar-light')
                document.body.classList.remove('center-menu')
            },

            /**
             * Light Topbar
             */
            lightMenubar() {
                document.body.classList.add('menubar-light')
                document.body.classList.add('topbar-dark')
                document.body.classList.remove('boxed-layout')
                document.body.classList.remove('center-menu')
                document.body.classList.remove('gradient-topbar')
                document.body.classList.remove('unsticky-header')
            },

            /**
             * Show menu in center
             */
            centerMenu() {
                document.body.classList.add('center-menu')
                document.body.classList.remove('topbar-dark')
                document.body.classList.remove('menubar-light')
                document.body.classList.remove('boxed-layout')
                document.body.classList.remove('gradient-topbar')
            },

            gradientTopbar() {
                document.body.classList.add('gradient-topbar')
                document.body.classList.add('topbar-dark')
                document.body.classList.remove('drop-menu-dark')
                document.body.classList.remove('unsticky-header')
                document.body.classList.remove('center-menu')
            },

            dropmenuDark() {
                document.body.classList.add('drop-menu-dark')
                document.body.classList.remove('gradient-topbar')
                document.body.classList.remove('boxed-layout')
                document.body.classList.remove('center-menu')
                document.body.classList.remove('menubar-light')
            },
            /**
             * Unsticky Header
             */
            unstickyHeader() {
                document.body.classList.add('unsticky-header')
                document.body.classList.remove('boxed-layout')
                document.body.classList.remove('center-menu')
                document.body.classList.remove('drop-menu-dark')
                document.body.classList.remove('topbar-dark')
                document.body.classList.remove('menubar-light')
            },

            /**
             * Boxed Layout
             */
            boxedLayout() {
                document.body.classList.add('boxed-layout')
                document.body.classList.remove('drop-menu-dark')
                document.body.classList.remove('gradient-topbar')
                document.body.classList.remove('topbar-dark')
                document.body.classList.remove('menubar-light')
            },
        },
        created () {
            if (store.getters['auth/loggedIn']) {
                this.$store.dispatch('getDistrict')
            }
            if (store.getters['auth/loggedIn']) {
                this.$store.dispatch('getLoginUser')
            }
            if (store.getters['auth/loggedIn']) {
                this.$store.dispatch('getEntitledCategory')
            }
            if (store.getters['auth/loggedIn']) {
              this.$store.dispatch('getUserRole')
            }
            if (store.getters['auth/loggedIn']) {
              this.$store.dispatch('getUserPermission')
          }
        },
    }
</script>

<template>
    <!-- Topbar Start -->
    <div class="topbar-menu">
        <div class="container-fluid">
            <b-collapse
                    id="navigation"
                    v-model="isMenuOpened"
            >
                <!-- Navigation Menu-->
                <ul class="navigation-menu">
                    <li>
                        <router-link tag="a" to="/"><i class="fe-home"></i><span>Dashboard</span></router-link>
                    </li>
                    <li v-if="userPermission.includes('menu-show')" class="has-submenu">
                        <a href="#" @click="onMenuClick"><i class="fe-grid"></i>Data
                            <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                            <li>
                                <router-link tag="a" to="/ses/ep-id/create" class="side-nav-link-ref">Create EP ID</router-link>
                            </li>
                            <li class="has-submenu">
                                <a href="#" @click="onMenuClick">SES
                                    <div class="arrow-down"></div>
                                </a>
                                <ul class="submenu">
                                    <li>
                                        <router-link tag="a" to="/ses/create" class="side-nav-link-ref">Create SES</router-link>
                                    </li>
                                    <li>
                                        <router-link tag="a" to="/ses/update" class="side-nav-link-ref">Update SES</router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="has-submenu">
                            <a href="#" @click="onMenuClick">Add Info
                              <div class="arrow-down"></div>
                            </a>
                              <ul class="submenu">
                                <li  v-if="userPermission.includes('award-book-list')">
                                  <router-link tag="a" to="/award-book/list" class="side-nav-link-ref">Add Award Book</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/ccl/list" class="side-nav-link-ref">Add CCL</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/trainee/list" class="side-nav-link-ref">TNA</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/trainee/batch/list" class="side-nav-link-ref">Batch</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/ses/present-address/create" class="side-nav-link-ref">Add Present Address</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/ses/bank/create" class="side-nav-link-ref">Add Bank Info</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/ses/document/list" class="side-nav-link-ref">Ses Document</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/rrc/ses/list" class="side-nav-link-ref">RRC</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/jvc/list" class="side-nav-link-ref">Create JVC</router-link>
                                </li>

                                <li>
                                  <router-link tag="a" to="/jvr/list" class="side-nav-link-ref">Create JVR</router-link>
                                </li>

                                <li>
                                  <router-link tag="a" to="/jvc_ses/list" class="side-nav-link-ref">Add EP to JVC</router-link>
                                </li>

                                <li>
                                  <router-link tag="a" to="/ses/list" class="side-nav-link-ref">Add JVR to SES</router-link>
                                </li>
<!--                                <li class="has-submenu">-->
<!--                                  <a href="#" @click="onMenuClick">Data Cross Check-->
<!--                                    <div class="arrow-down"></div>-->
<!--                                  </a>-->
<!--                                  <ul class="submenu">-->
<!--                                    <li>-->
<!--                                      <router-link tag="a" to="/cross-check/ps-ab-ccl/list" class="side-nav-link-ref">PS AB CCLS</router-link>-->
<!--                                    </li>-->
<!--                                  </ul>-->
<!--                                </li>-->
                              </ul>
                            </li>
<!--                            <li class="has-submenu">-->
<!--                              <a href="#" @click="onMenuClick">File Tracking-->
<!--                                <div class="arrow-down"></div>-->
<!--                              </a>-->
<!--                              <ul class="submenu">-->
<!--                                <li>-->
<!--                                  <router-link tag="a" to="/ep/file-tracking/list" class="side-nav-link-ref">EP List</router-link>-->
<!--                                </li>-->
<!--                              </ul>-->
<!--                          </li>-->

                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Prepare Estimates
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li class="has-submenu">
                                  <a href="#" @click="onMenuClick">Titled
                                    <div class="arrow-down"></div>
                                  </a>
                                  <ul class="submenu">
                                    <li v-for="(district, index) in districts" :key="index">
                                      <router-link  tag="a" :to="{name: 'estimateList', params: {ep_type: 1, district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                    </li>
                                  </ul>
                                </li>
                                <li class="has-submenu">
                                  <a href="#" @click="onMenuClick">Non-titled / Squatters
                                    <div class="arrow-down"></div>
                                  </a>
                                  <ul class="submenu">
                                    <li v-for="(district, index) in districts" :key="index">
                                      <router-link tag="a" :to="{name: 'estimateNonTitleList', params: {ep_type: 0, district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                            <a href="#" @click="onMenuClick">Prepare Estimates Calculation
                              <div class="arrow-down"></div>
                            </a>
                            <ul class="submenu">
                              <li class="has-submenu">
                                <a href="#" @click="onMenuClick">Titled
                                  <div class="arrow-down"></div>
                                </a>
                                <ul class="submenu">
                                  <li v-for="(district, index) in districts" :key="index" >
                                    <router-link tag="a" :to="{name: 'estimateCalculationList', params: {ep_type: 1, district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                  </li>
                                </ul>
                              </li>
                              <li class="has-submenu">
                                <a href="#" @click="onMenuClick">Non-titled / Squatters
                                  <div class="arrow-down"></div>
                                </a>
                                <ul class="submenu">
                                  <li v-for="(district, index) in districts" :key="index" >
                                    <router-link tag="a" :to="{name: 'estimateCalculationList', params: {ep_type: 0, district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Print
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li class="has-submenu">
                                  <a href="#" @click="onMenuClick">Debited Cheque Print
                                    <div class="arrow-down"></div>
                                  </a>
                                  <ul class="submenu">
                                    <li class="has-submenu" v-for="(district, index) in districts" :key="index">
                                      <a href="#" @click="onMenuClick">{{ district.district_desc }}<div class="arrow-down"></div></a>
                                      <ul class="submenu">
                                        <li>
                                          <router-link tag="a" :to="{name: 'paymentViewVoucher', params: { district_id: district.id, ep_type: 1 }}"  class="side-nav-link-ref">Title</router-link>
                                        </li>
                                        <li>
                                          <router-link tag="a" :to="{name: 'paymentViewVoucher', params: { district_id: district.id, ep_type: 0 }}"  class="side-nav-link-ref">Non-titled / Squatters</router-link>
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </li>
                                <li class="has-submenu">
                                  <a href="#" @click="onMenuClick">Undebited Cheque Print
                                    <div class="arrow-down"></div>
                                  </a>
                                  <ul class="submenu">
                                    <li class="has-submenu" v-for="(district, index) in districts" :key="index">
                                      <a href="#" @click="onMenuClick">{{ district.district_desc }}<div class="arrow-down"></div></a>
                                      <ul class="submenu">
                                        <li>
                                          <router-link tag="a" :to="{name: 'paymentVoucherPrint', params: { district_id: district.id, ep_type: 1 }}"  class="side-nav-link-ref">Title</router-link>
                                        </li>
                                        <li>
                                          <router-link tag="a" :to="{name: 'paymentVoucherPrint', params: { district_id: district.id, ep_type: 0 }}"  class="side-nav-link-ref">Non-titled / Squatters</router-link>
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </li>
                                <!--                        <li class="has-submenu">-->
                                <!--                          <a href="#" @click="onMenuClick">Print EP/EC/Vouchers-->
                                <!--                            <div class="arrow-down"></div>-->
                                <!--                          </a>-->

                                <!--                          <ul class="submenu">-->
                                <!--                            <li v-for="(district, index) in districts" :key="index">-->
                                <!--                              <router-link tag="a" :to="{name: 'printEpEcVoucherList', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>-->
                                <!--                            </li>-->
                                <!--                          </ul>-->
                                <!--                        </li>-->
                                <li>
                                  <router-link tag="a" to="/ses/cheque/create" class="side-nav-link-ref">Custom Cheque Print</router-link>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Add Individual Vouchers info
                                <div class="arrow-down"></div>
                              </a>

                              <ul class="submenu">
                                <li v-for="(district, index) in districts" :key="index">
                                  <router-link tag="a" :to="{name: 'individualVoucherInfoList', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Upload
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li class="has-submenu">
                                  <a href="#" @click="onMenuClick">JVC
                                    <div class="arrow-down"></div>
                                  </a>
                                  <ul class="submenu">
                                    <li>
                                      <router-link tag="a" to="/report/jvc/create" class="side-nav-link-ref">Add JVC Report</router-link>
                                    </li>
                                    <li>
                                      <router-link tag="a" to="/report/jvc/list" class="side-nav-link-ref">JVC List</router-link>
                                    </li>
                                  </ul>
                                </li>
                                <li class="has-submenu">
                                  <a href="#" @click="onMenuClick">Estimate
                                    <div class="arrow-down"></div>
                                  </a>
                                  <ul class="submenu">
                                    <li>
                                      <router-link tag="a" to="/report/estimate/list" class="side-nav-link-ref">Estimate List</router-link>
                                    </li>
                                  </ul>
                                </li>
                                <li class="has-submenu">
                                  <a href="#" @click="onMenuClick">Weekly
                                    <div class="arrow-down"></div>
                                  </a>
                                  <ul class="submenu">
                                    <li>
                                      <router-link tag="a" to="/weekly/create" class="side-nav-link-ref">Add Weekly Report</router-link>
                                    </li>
                                    <li>
                                      <router-link tag="a" to="/weekly/list" class="side-nav-link-ref">Weekly List</router-link>
                                    </li>
                                  </ul>
                                </li>
                                <li class="has-submenu">
                                  <a href="#" @click="onMenuClick">Monthly
                                    <div class="arrow-down"></div>
                                  </a>
                                  <ul class="submenu">
                                    <li>
                                      <router-link tag="a" to="/monthly/create" class="side-nav-link-ref">Add Monthly Report</router-link>
                                    </li>
                                    <li>
                                      <router-link tag="a" to="/monthly/list" class="side-nav-link-ref">Monthly List</router-link>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                                <a href="#" @click="onMenuClick">Add Rate
                                    <div class="arrow-down"></div>
                                </a>
                                <ul class="submenu">
                                    <li>
                                        <router-link tag="a" to="/rate/land/list" class="side-nav-link-ref">Land/Mouza Rate</router-link>
                                    </li>
                                    <li>
                                        <router-link tag="a" to="/rate/structure/list" class="side-nav-link-ref">Structure Rate</router-link>
                                    </li>
                                    <li>
                                        <router-link tag="a" to="/rate/tree/list" class="side-nav-link-ref">Tree Rate</router-link>
                                    </li>
                                </ul>
                            </li>
                            <li v-if="userRole.includes('Super Admin') || userRole.includes('Admin')" class="has-submenu">
                              <a href="#" @click="onMenuClick">User
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <!--                            <li>-->
                                <!--                              <router-link tag="a" to="/user/info" class="side-nav-link-ref">User Info</router-link>-->
                                <!--                            </li>-->
                                <li v-if="userRole.includes('Super Admin') || userRole.includes('Admin')">
                                  <router-link tag="a" to="/user/list" class="side-nav-link-ref">All User</router-link>
                                </li>
                                <li v-if="userRole.includes('Super Admin') || userRole.includes('Admin')">
                                  <router-link tag="a" to="/user/role/list" class="side-nav-link-ref">Roles</router-link>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                                <a href="#" @click="onMenuClick">Manage EP/EC/Vouchers
                                    <div class="arrow-down"></div>
                                </a>

                                <ul class="submenu">
                                    <li v-for="(district, index) in districts" :key="index">
                                        <router-link tag="a" :to="{name: 'voucherEpEcVoucherList', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                              <router-link tag="a" to="/ses/power/group/create" class="side-nav-link-ref">Manage Power EP</router-link>
                            </li>
<!--                          <li>-->
<!--                            <router-link tag="a" to="/plot-schedule/upload" class="side-nav-link-ref">Plot Schedule Upload</router-link>-->
<!--                          </li>-->

                          <li class="has-submenu">
                            <a href="#" @click="onMenuClick">Report
                              <div class="arrow-down"></div>
                            </a>

                            <ul class="submenu">
                              <li>
                                <router-link tag="a" :to="{}" class="side-nav-link-ref">Budget</router-link>
                              </li>
                            </ul>
                          </li>

                        </ul>
                    </li>
                    <li class="has-submenu">
                        <a href="#" @click="onMenuClick"><i class="fe-grid"></i>View
                            <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                            <li class="has-submenu">
                                <a href="#" @click="onMenuClick">SES
                                    <div class="arrow-down"></div>
                                </a>
                                <ul class="submenu">
                                    <li>
                                        <router-link tag="a" to="/ses/view/list" class="side-nav-link-ref">Search SES</router-link>
                                    </li>
                                    <li>
                                        <router-link tag="a" to="/ses/document/list" class="side-nav-link-ref">SES Document</router-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                              <router-link tag="a" to="/ep/search" class="side-nav-link-ref">EP Search</router-link>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Power EPs
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li v-for="(district, index) in districts" :key="index" >
                                  <router-link tag="a" :to="{name: 'powerEpView', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Vulnerable
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li class="has-submenu" v-for="(district, index) in districts" :key="index">
                                  <a href="#" @click="onMenuClick">{{ district.district_desc }}<div class="arrow-down"></div></a>
                                  <ul class="submenu">
                                    <li>
                                      <router-link tag="a" :to="{name: 'vulnerableViewList', params: {ep_type: 1, district_id: district.id}}"  class="side-nav-link-ref">Title</router-link>
                                    </li>
                                    <li>
                                      <router-link tag="a" :to="{name: 'vulnerableViewList', params: {ep_type: 0, district_id: district.id}}"  class="side-nav-link-ref">Non-titled / Squatters</router-link>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">EP/EC/Vouchers<div class="arrow-down"></div></a>
                              <ul class="submenu">
                                <li v-for="(district, index) in districts" :key="index">
                                  <router-link tag="a" :to="{name: 'debitedEpEcVoucherList', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Rates
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li>
                                  <router-link tag="a" to="/rate/land/view" class="side-nav-link-ref">Land</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/rate/structure/view" class="side-nav-link-ref">Structure</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/rate/tree/view" class="side-nav-link-ref">Tree</router-link>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Acquired Land status
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li>
                                  <router-link tag="a" to="/land/plot/list" class="side-nav-link-ref">Plot</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/land/mouza/list" class="side-nav-link-ref">Mouza</router-link>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Land Info
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li v-for="(district, index) in districts" :key="index">
                                  <router-link tag="a" :to="{name: 'landInfoView', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">CCL
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li>
                                  <router-link tag="a" to="/ccl/view/list" class="side-nav-link-ref">CCL</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/ccl/mouza/view/list" class="side-nav-link-ref">CCL Mouza</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/ccl/plot/view/list" class="side-nav-link-ref">CCL Plot</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/ccl/district/view/list" class="side-nav-link-ref">CCL District</router-link>
                                </li>
                              </ul>
                            </li>

                          <li class="has-submenu">
                            <a href="#" @click="onMenuClick">JVR
                              <div class="arrow-down"></div>
                            </a>
                            <ul class="submenu">
                              <li>
                                <router-link tag="a" to="/jvr/view/list" class="side-nav-link-ref">View JVR</router-link>
                              </li>
                            </ul>
                          </li>
                          <li class="has-submenu">
                            <a href="#" @click="onMenuClick">JVC
                              <div class="arrow-down"></div>
                            </a>
                            <ul class="submenu">
                              <li>
                                <router-link tag="a" to="/jvc/view/list" class="side-nav-link-ref">View JVC</router-link>
                              </li>
                            </ul>
                          </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Vulnerable
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li v-for="(district, index) in districts" :key="index" >
                                  <router-link tag="a" :to="{name: 'vulnerableWithOutTypeList', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Age<div class="arrow-down"></div></a>
                              <ul class="submenu">
                                <li v-for="(district, index) in districts" :key="index">
                                  <router-link tag="a" :to="{name: 'ageViewList', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Upload
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li>
                                  <router-link tag="a" to="/report/jvc" class="side-nav-link-ref">JVC</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/report/estimate" class="side-nav-link-ref">Estimate</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/report/monthly" class="side-nav-link-ref">Monthly</router-link>
                                </li>
                                <li>
                                  <router-link tag="a" to="/report/weekly" class="side-nav-link-ref">Weekly</router-link>
                                </li>
                              </ul>
                            </li>
<!--                            <li>-->
<!--                             <router-link tag="a" to="/unpaid/ep/count" class="side-nav-link-ref">Unpaid EP Count</router-link>-->
<!--                            </li>-->
                            <li>
                              <router-link tag="a" to="/ses/bank/list" class="side-nav-link-ref">Bank Info</router-link>
                            </li>
                            <li>
                              <router-link tag="a" to="/trainee/list/view" class="side-nav-link-ref">TNA</router-link>
                            </li>
                            <li>
                              <router-link tag="a" to="/batch/trainee/view/list" class="side-nav-link-ref">Batch</router-link>
                            </li>
                            <li>
                              <router-link tag="a" to="/award-book/view/list" class="side-nav-link-ref">Award Book</router-link>
                            </li>
                            <li>
                                <router-link tag="a" to="/rrc/view/list" class="side-nav-link-ref">RRC</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="has-submenu">
                      <a href="#" @click="onMenuClick"><i class="fe-grid"></i>Entitled Persons
                        <div class="arrow-down"></div>
                      </a>
                      <ul class="submenu">
                        <li v-for="(district, index) in districts" :key="index">
                          <router-link tag="a" :to="{name: 'epDistrict', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                        </li>
                      </ul>
                    </li>
                  <li class="has-submenu">
                    <a href="#" @click="onMenuClick">Owners
                      <div class="arrow-down"></div>
                    </a>

                    <ul class="submenu">
                      <li class="has-submenu">
                        <a href="#" @click="onMenuClick">Land Owners
                          <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                          <li v-for="(district, index) in districts" :key="index">
                            <router-link tag="a" :to="{name: 'ownerLandView', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                          </li>
                        </ul>
                      </li>

                      <li class="has-submenu">
                        <a href="#" @click="onMenuClick">Structure Owners
                          <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                          <li v-for="(district, index) in districts" :key="index">
                            <router-link tag="a" :to="{name: 'ownerStructureView', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                          </li>
                        </ul>
                      </li>
                      <li class="has-submenu">
                        <a href="#" @click="onMenuClick">Tree Owners
                          <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                          <li v-for="(district, index) in districts" :key="index">
                            <router-link tag="a" :to="{name: 'ownerTreeView', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                          </li>
                        </ul>
                      </li>
                      <li class="has-submenu">
                        <a href="#" @click="onMenuClick">Crops/Fish Owners
                          <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                          <li v-for="(district, index) in districts" :key="index">
                            <router-link tag="a" :to="{name: 'ownerCropFishView', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                          </li>
                        </ul>
                      </li>

                      <li class="has-submenu">
                        <a href="#" @click="onMenuClick">Business Owners
                          <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                          <li v-for="(district, index) in districts" :key="index">
                            <router-link tag="a" :to="{name: 'ownerBusinessView', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                          </li>
                        </ul>
                      </li>

                      <li class="has-submenu">
                        <a href="#" @click="onMenuClick">Residential Owners
                          <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                          <li v-for="(district, index) in districts" :key="index">
                            <router-link tag="a" :to="{name: 'ownerResidentialView', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                          </li>
                        </ul>
                      </li>
                      <li class="has-submenu">
                        <a href="#" @click="onMenuClick">Employees
                          <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                          <li v-for="(district, index) in districts" :key="index">
                            <router-link tag="a" :to="{name: 'ownerEmployeesView', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                          </li>
                        </ul>
                      </li>
                      <li class="has-submenu">
                        <a href="#" @click="onMenuClick">Vulnerable
                          <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                          <li v-for="(district, index) in districts" :key="index">
                            <router-link tag="a" :to="{name: 'ownerVulnerableView', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                          </li>
                        </ul>
                      </li>

                    </ul>
                  </li>
                    <li class="has-submenu">
                        <a href="#" @click="onMenuClick"><i class="fe-grid"></i>Payment
                            <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Payment in Progress
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li class="has-submenu" v-for="(district, index) in districts" :key="index">
                                  <a href="#" @click="onMenuClick">{{ district.district_desc }}<div class="arrow-down"></div></a>
                                  <ul class="submenu">
                                    <li>
                                      <router-link tag="a" :to="{name: 'paymentInProgressList', params: {ep_type: 1, district_id: district.id}}"  class="side-nav-link-ref">Title</router-link>
                                    </li>
                                    <li>
                                      <router-link tag="a" :to="{name: 'paymentInProgressList', params: {ep_type: 0, district_id: district.id}}"  class="side-nav-link-ref">Non-titled / Squatters</router-link>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Individual Payment
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li class="has-submenu" v-for="(district, index) in districts" :key="index">
                                  <a href="#" @click="onMenuClick">{{ district.district_desc }}<div class="arrow-down"></div></a>
                                  <ul class="submenu">
                                    <li>
                                      <router-link tag="a" :to="{name: 'individualPaymentList', params: {ep_type: 1, district_id: district.id}}"  class="side-nav-link-ref">Title</router-link>
                                    </li>
                                    <li>
                                      <router-link tag="a" :to="{name: 'individualPaymentList', params: {ep_type: 0, district_id: district.id}}"  class="side-nav-link-ref">Non-titled / Squatters</router-link>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Payment Completed
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li class="has-submenu" v-for="(district, index) in districts" :key="index">
                                  <a href="#" @click="onMenuClick">{{ district.district_desc }}<div class="arrow-down"></div></a>
                                  <ul class="submenu">
                                    <li>
                                      <router-link tag="a" :to="{name: 'paymentCompleted', params: {district_id: district.id,ep_type: 1}}"  class="side-nav-link-ref">Title</router-link>
                                    </li>
                                    <li>
                                      <router-link tag="a" :to="{name: 'paymentCompleted', params: {district_id: district.id,ep_type: 0}}"  class="side-nav-link-ref">Non-titled / Squatters</router-link>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Payment Completed By Power
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li class="has-submenu" v-for="(district, index) in districts" :key="index">
                                  <a href="#" @click="onMenuClick">{{ district.district_desc }}<div class="arrow-down"></div></a>
                                  <ul class="submenu">
                                    <li>
                                      <router-link tag="a" :to="{name: 'paymentCompletedByPower', params: {district_id: district.id,ep_type: 1}}"  class="side-nav-link-ref">Title</router-link>
                                    </li>
                                    <li>
                                      <router-link tag="a" :to="{name: 'paymentCompletedByPower', params: {district_id: district.id,ep_type: 0}}"  class="side-nav-link-ref">Non-titled / Squatters</router-link>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Payment EP
                                <div class="arrow-down"></div>
                              </a>

                              <ul class="submenu">
                                <li v-for="(district, index) in districts" :key="index">
                                  <router-link tag="a" :to="{name: 'districtPaymentEP', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>
                                </li>
                              </ul>
                            </li>
                            <li class="has-submenu">
                                <a href="#" @click="onMenuClick">Entitlement District
                                    <div class="arrow-down"></div>
                                </a>
                                <ul class="submenu" style="height: 200px; overflow-x: hidden; overflow-y: auto;">
                                    <li v-for="(entitled_category, index) in entitled_categories" :key="index">
                                        <router-link  tag="a" :to="{name: 'entitlementDistrict', params: {entitled_category_id: entitled_category.id}}" class="side-nav-link-ref">{{ entitled_category.short_code }}</router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="has-submenu">
                              <a href="#" @click="onMenuClick">Entitlement Individual
                                <div class="arrow-down"></div>
                              </a>
                              <ul class="submenu">
                                <li class="has-submenu" v-for="(district, index) in districts" :key="index">
                                  <a href="#" @click="onMenuClick">{{ district.district_desc }}<div class="arrow-down"></div></a>
                                  <ul class="submenu" style="height: 200px; overflow-x: hidden; overflow-y: auto;">
                                    <li v-for="(entitled_category, index) in entitled_categories" :key="index">
                                      <router-link tag="a" :to="{name: 'entitlementIndividual', params: {district_id: district.id, entitled_category_id: entitled_category.id}}" class="side-nav-link-ref">{{ entitled_category.short_code }}</router-link>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
<!--                            <li class="has-submenu">-->
<!--                              <a href="#" @click="onMenuClick">EP/EC/Vouchers-->
<!--                                <div class="arrow-down"></div>-->
<!--                              </a>-->

<!--                              <ul class="submenu">-->
<!--                                <li v-for="(district, index) in districts" :key="index">-->
<!--                                  <router-link tag="a" :to="{name: 'voucherEpEcVoucherView', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>-->
<!--                                </li>-->
<!--                              </ul>-->
<!--                            </li>-->
<!--                            <li class="has-submenu">-->
<!--                              <a href="#" @click="onMenuClick">Mouza Wise Payment-->
<!--                                <div class="arrow-down"></div>-->
<!--                              </a>-->

<!--                              <ul class="submenu">-->
<!--                                <li v-for="(district, index) in districts" :key="index">-->
<!--                                  <router-link tag="a" :to="{name: 'paymentMouza', params: {district_id: district.id}}" class="side-nav-link-ref">{{ district.district_desc }}</router-link>-->
<!--                                </li>-->
<!--                              </ul>-->
<!--                            </li>-->
                            <li>
                               <router-link tag="a" to="/payment/power/breakdown" class="side-nav-link-ref">Power Payment Breakdown</router-link>
                            </li>
                            <li>
                              <router-link tag="a" to="/payment/statement/list" class="side-nav-link-ref">Payment Statement</router-link>
                            </li>
                            <li>
                              <router-link tag="a" to="/entitlement/district/all" class="side-nav-link-ref">Entitlement District All</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="has-submenu">
                        <a href="#" @click="onMenuClick"><i class="fe-layers"></i>Report
                            <div class="arrow-down"></div>
                        </a>
                        <ul class="submenu">
                            <li>
                              <router-link tag="a" to="/report/jvc" class="side-nav-link-ref">JVC</router-link>
                            </li>
                            <li>
                              <router-link tag="a" to="/report/estimate" class="side-nav-link-ref">Estimate</router-link>
                            </li>
                            <li>
                                <router-link tag="a" to="/report/monthly" class="side-nav-link-ref">Monthly</router-link>
                            </li>
                            <li>
                                <router-link tag="a" to="/report/weekly" class="side-nav-link-ref">Weekly</router-link>
                            </li>
                            <li>
                              <router-link tag="a" to="/report/jvrs" class="side-nav-link-ref">JVRS</router-link>
                            </li>
<!--                          <li>-->
<!--                            <router-link tag="a" to="/report/ses" class="side-nav-link-ref">Ses</router-link>-->
<!--                          </li>-->
<!--                          <li>-->
<!--                            <router-link tag="a" to="/report/ses/bank" class="side-nav-link-ref">Ses Bank</router-link>-->
<!--                          </li>-->
                        </ul>
                    </li>
                    <li>
                    <router-link tag="a" to="/faq"><i class="fe-help-circle"></i><span>FAQ</span></router-link>
                  </li>
                    <li class="float-right mb-0 has-submenu">
                        <a href="#" @click="onMenuClick">
                            <div class="nav-user mr-0">
                                <img src="@assets/images/railway.jpg" alt="user-image" class="rounded-circle"/>
                                <span style="color: #d6e2df; margin-right: 2px" class="pro-user-name ml-1">{{user ? user.name : ''}}</span>
                                <div class="arrow-down"></div>
                            </div>
                        </a>
                        <ul class="submenu">
                            <li>
                                <router-link tag="a" to="/user/profile" class="side-nav-link-ref">
                                    <i class="fe-user mr-1"></i>
                                    <span>My Account</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link tag="a" to="/logout" class="side-nav-link-ref">
                                    <i class="fe-log-out mr-1"></i>
                                    <span>Logout</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                </ul>
                <!-- End navigation menu -->

                <div class="clearfix"></div>
            </b-collapse>
            <!-- end #navigation -->
        </div>
        <!-- end container -->
    </div>
    <!-- end navbar-custom -->
</template>

<style lang="scss">
    /*.profile*/
    .profile > ul > li > a:hover{
        color: #111111
    }

    /*.profile > ul:hover{*/
    /*    background-color: #38414a1a;*/
    /*}*/
</style>
